import {Body, Caption} from "#app/components/Text/styles";
import {CurrencyConstants, Money} from "finhelper";
import React from "react";

export const SumDisplay = ({ item, isNotVisibleSum, currencyId }) => (
    <div data-id='sum' style={{ display: 'flex', flexWrap: 'wrap', flexBasis: item.relation_sum > 0 ? '70%' : '100%' }}>
        <Body left full>{isNotVisibleSum ? '******' : Money.format(Math.abs(item.sum)) + ' ' + CurrencyConstants.getCurrencySignById(currencyId)}</Body>
        {item.relation_sum > 0 && (
            <Caption left grey full>
                {isNotVisibleSum ? '******' : Money.format(item.relation_sum) + ' ' + CurrencyConstants.getCurrencySignById(currencyId)}
            </Caption>
        )}
    </div>
);